import React,{useEffect} from 'react';
import './ServicesPage.css';
import AOS from 'aos';
import WbIncandescentIcon from '@mui/icons-material/WbIncandescent';

const StreetLightServices = () => {
    useEffect(() => {
        AOS.init();
       
            window.scrollTo(0, 0)
         
      }, [])
  return (
    <div className='container-fluid' id='street-light-services'>

    <div className="row first-row" data-aos="fade-up" data-aos-offset="200"  data-aos-duration="1000">
      <div className="col text-col" data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000">
          <h1>We Provides Top-notch <br />
          Street Light Automation Services</h1>
          <p> "<b>Unique Technologies</b> revolutionizes urban landscapes with its cutting-edge Street Light Automation System, seamlessly integrating advanced technology to optimize energy consumption, enhance safety, and elevate efficiency, ensuring cities shine brighter while reducing environmental impact."</p>
      </div>
      <div className="col img-col"></div>
    </div>

    <div className="container-fluid" id='centralized-street-light-control'>
        
        <div className="row">
            <div className="col"><img src="/img-data/services-page/street-light-automation-services/feature-1.png" alt="" />
            <p>Reduced Energy Expenditure</p>
            </div>
            <div className="col"><img src="/img-data/services-page/street-light-automation-services/feature-2.png" alt="" />
            <p>Energy Efficiency</p>
            </div>
            <div className="col"><img src="/img-data/services-page/street-light-automation-services/feature-3.png" alt="" />
            <p>Real-time Energy Cosumption Monitoring</p>
            </div>
            <div className="col"><img src="/img-data/services-page/street-light-automation-services/feature-4.png" alt="" />
            <p>Maintenance Alerts</p>
            </div>
            <div className="col"><img src="/img-data/services-page/street-light-automation-services/feature-5.png" alt="" />
            <p>Centralized Dashboard</p>
            </div>
            
        </div>
        <div className='second-row'>
            <h1>CENTRALIZED STREET LIGHT CONTROL</h1>
            <p>Sync & Secure's Street Lights Control System aims to bring intelligence and visibility in the street lighting infrastructure, making efficient management of energy consumption possible. The Streetlights Control System enables smart management of individual, group or system-wide network of streetlights, providing control of when and how brightly the streetlights should be lit.
Management of streetlights becomes easy in real-time via our application's real-time alert capability, notifying operators in real-time about hardware malfunctions for cost-effective actionable maintenance. Operators can also respond in real-time to factors such as automatic light switching and targeted dimming, while monitoring all streetlight operations on a centralized dashboard or mobile application.
Consult with us today and learn how the streetlights infrastructure can function seamlessly and autonomously by transforming them with our IoT-enabled Streetlights Control System.</p>
            <img src="/img-data/services-page/street-light-automation-services/centralized-street-light-control.png" alt="" />
        </div>

        <div className="advantages-and-benifits">
            <h2>Advantage and Benifits</h2>
            <div className="row">
                <div className="col">
                    <p><WbIncandescentIcon/> Programmable real time operation of Street Lights with sunset and sunrise time.</p>
                    <p><WbIncandescentIcon/> Dimming at Off Peak hours</p>
                    <p><WbIncandescentIcon/> SMS to Maintenance Field staff in an event of fault</p>
                    <p><WbIncandescentIcon/> Remote Energy Metering</p>
                    <p><WbIncandescentIcon/> Report of Operating and Non Operating Lamps and Theft control detection</p>
                    <p><WbIncandescentIcon/> Option of single Photo cell connected to Control Station </p>
                    <p><WbIncandescentIcon/> Power quality analysis</p>
                    <p><WbIncandescentIcon/> Consumption Alarm</p>
                    <p><WbIncandescentIcon/> Over / Under voltage</p>
                    <p><WbIncandescentIcon/> Mains Breaker Trip </p>
                    <p><WbIncandescentIcon/> Contractor fault</p>
                    <p><WbIncandescentIcon/> Outgoing MCCB Trip</p>
                    <p><WbIncandescentIcon/> Circuit phase errors</p>
                    <p><WbIncandescentIcon/> Mains Power Failure</p>
                    <p><WbIncandescentIcon/> Leakage to Ground</p>

                </div>
                <div className="col">
                    <p><WbIncandescentIcon/> Fast reaction to traffic and weather conditions</p>
                    <p><WbIncandescentIcon/> Burn Hour report</p>
                    <p><WbIncandescentIcon/> Simplified maintenance</p>
                    <p><WbIncandescentIcon/> Real time Control</p>
                    <p><WbIncandescentIcon/> Load Balancing</p>
                    <p><WbIncandescentIcon/> Neutral Break Fault protection</p>
                    <p><WbIncandescentIcon/> Area specific settings</p>
                    <p><WbIncandescentIcon/> Automatic Report Generation for Day/Month/Year</p>
                    <p><WbIncandescentIcon/> Control cabinet door open</p>
                    <p><WbIncandescentIcon/> Flashing of failure of bulbs</p>
                    <p><WbIncandescentIcon/> Power Theft</p>
                    <p><WbIncandescentIcon/> Netural</p>
                    <p><WbIncandescentIcon/> Low Power factor</p>
                    <p><WbIncandescentIcon/> Manual switch activated</p>
                    <p><WbIncandescentIcon/> Phase unbalancing</p>
                    <p><WbIncandescentIcon/> Phase current out of range</p>
                </div>
            </div>
        </div>

        <div className="system-features">
            <h1>Features</h1>
            <div className="features">
                <div className='features-wrapper'>
                    <div className='feature-1'>
                    <p>Lighting Segment Dimming/Lighting As Per Traffic</p>
                    </div>
                    <div className='feature-2'>
                    <p>Segment Control For 3 Dimming Levels & On/OFF</p>
                    </div>
                    <div className='feature-3'>
                    <p>User-Defined Dimming Timer</p>
                    </div>
                    <div className='feature-4'>
                    <p>Manual/Automatic Mode</p>
                    </div>
                    <div className='feature-5'>
                    <p>Monitoring On Mobile App and Dashboard</p>
                    </div>
                    <div className='feature-6'>
                    <p>Centralized Dashboard/Application For Multiple Systems</p>
                    </div>
                    
                   
                   
                </div>
            </div>
        </div>
    </div>




    {/* <div className="row top-heading-row" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
          <h2>Our Six Step <br />
          working Process for Street Light <br /> Automation Services</h2>
      </div>
  <div className="row second-row" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
   <div className="col oddcol first-col">
      <div className="row">
          <div className="col text-col" data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000">
              <h3>1.Assessment and Planning: </h3>
              <p> Our team conducts a thorough assessment of the current street lighting infrastructure and collaborates with clients to understand their specific needs and goals.</p>
          </div>
          <div className="col first-img-col"></div>
      </div>
   </div>
   <div className="col evencol second-col" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
   <div className="row">
   <div className="col second-img-col"></div>
          <div className="col text-col" data-aos="fade-left" data-aos-offset="300"  data-aos-duration="1000">
              <h3>2.Customized Solution Design:  </h3>
              <p>Based on the assessment, we design a tailor-made street light automation system incorporating advanced sensors, controllers, and communication technologies to optimize efficiency and performance.</p>
          </div>

      </div>
   </div>
   <div className="col oddcol third-col" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
   <div className="row">
          <div className="col text-col" data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000">
              <h3>3.Installation and Integration: </h3>
              <p>Our experienced technicians install the automation hardware seamlessly, integrating it with existing street light fixtures and electrical systems while ensuring minimal disruption to daily operations.</p>
          </div>
          <div className="col third-img-col"></div>
      </div>
   </div>
   <div className="col evencol fourth-col" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
   <div className="row">
   <div className="col fourth-img-col"></div>
          <div className="col text-col" data-aos="fade-left" data-aos-offset="300"  data-aos-duration="1000">
              <h3>4.Programming and Configuration: </h3>
              <p>Once installed, our experts meticulously program and configure the system to meet the unique requirements of each location, fine-tuning parameters such as brightness levels, scheduling, and remote monitoring.</p>
          </div>

      </div>
   </div>
   <div className="col oddcol fifth-col" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
   <div className="row">
          <div className="col text-col" data-aos="fade-right" data-aos-offset="300"  data-aos-duration="1000">
              <h3>5.Testing and Quality Assurance </h3>
              <p>Rigorous testing is conducted to ensure the system operates flawlessly under various conditions, guaranteeing reliability, durability, and adherence to industry standards.</p>
          </div>
          <div className="col fifth-img-col"></div>
      </div>
   </div>
   <div className="col evencol sixth-col" data-aos="fade-up" data-aos-offset="300"  data-aos-duration="1000">
   <div className="row">
   <div className="col sixth-img-col"></div>
          <div className="col text-col" data-aos="fade-left" data-aos-offset="300"  data-aos-duration="1000">
              <h3>6.Training and Support  </h3>
              <p>We provide comprehensive training sessions for maintenance personnel and administrators, empowering them to effectively manage and troubleshoot the system. Our dedicated support team remains available for ongoing assistance and updates to optimize system performance over time.</p>
          </div>

      </div>
   </div>
  </div> */}
  </div>
  )
}

export default StreetLightServices
